<template>
	<div class="top-header">
		<b-row>
			<b-col><b-img :src="require('../assets/foodoratorbanner.jpg')" fluid /></b-col>
		</b-row>
	</div>
</template>
<script>
export default {
	name: 'Header'
};
</script>
<style lang="scss">
</style>
